import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe implements PipeTransform {

  transform(value: number | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year} - ${hours}:${minutes}h`;
  }

  transformSemHora(value: number | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year}`;
  }
  transformSemHoraEDiaDaSemana(value: number | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    const day = this.padZero(date.getUTCDate());
    const month = this.padZero(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year} - `+this.getDiaSemanaCompleto(date);
  }

  transformSoHora(value: number | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${hours}:${minutes}h`;
  }

  transformSemHoraEAno(value: number | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${day}/${month} - `+this.getDiaSemana(date);
  }

  getDiaSemana(data: Date): string {
    const dias = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
    return dias[data.getDay()];
  }
  getDiaSemanaCompleto(data: Date): string {
    const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    return dias[data.getUTCDay()];
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
}